import ReactDOM from 'react-dom'
import cx from 'classnames'

import { useDisableScroll, useModalEventKeyBinding } from 'hooks'

const Modal = <K extends keyof JSX.IntrinsicElements>({
  isActive,
  title,
  children,
  onClose,
  footer = null,
  mode = 'default',
  className = undefined,
  autoWidth = false,
  autoWidthNoMaxWidth = false,
  autoHeight = false,
  fullWidth = false,
  noHeader = false,
  borderless = false,
  headerAction = null,
  afterHeader = null,
  stickToBottomModal = false,
  theme = 'default',
  showInnerClose = true,
  as = 'div' as K,
  wrapperProps,
}: {
  isActive: boolean
  title?: string
  children: any
  onClose: any
  footer?: any
  mode?: 'default' | 'back'
  className?: string
  autoWidth?: boolean
  autoWidthNoMaxWidth?: boolean
  autoHeight?: boolean
  fullWidth?: boolean
  noHeader?: boolean
  borderless?: boolean
  headerAction?: any
  afterHeader?: any
  stickToBottomModal?: boolean
  theme?: 'default' | 'dark'
  showInnerClose?: boolean
  as?: K
  wrapperProps?: JSX.IntrinsicElements[K]
}) => {
  const WrapperEl: any = as

  useModalEventKeyBinding({ isActive, onClose })

  useDisableScroll(isActive)

  if (!isActive) return null

  return ReactDOM.createPortal(
    <div
      className={cx('Modal', {
        'Modal--active': isActive,
        'Modal--stick-to-bottom': stickToBottomModal,
        [`Modal--${theme}`]: theme,
        [className]: className,
      })}
    >
      <a className="Modal__overlay" onClick={onClose} />

      <WrapperEl
        className={cx('Modal__wrapper', {
          'Modal__wrapper--auto-h': autoHeight,
          'Modal__wrapper--auto-w': autoWidth,
          'Modal__wrapper--auto-w--no-mw': autoWidthNoMaxWidth,
          'Modal__wrapper--fullwidth': fullWidth,
        })}
        {...wrapperProps}
      >
        {noHeader && showInnerClose && (
          <a className="Modal__close" onClick={onClose} />
        )}

        {!noHeader && (
          <div
            className={cx('Modal__header', {
              'Modal__header--borderless': borderless,
            })}
          >
            <a
              className={cx('Modal__header__close', {
                'Modal__header__close--back': mode === 'back',
              })}
              onClick={onClose}
            />

            <h2 className="Modal__header__h2">{title}</h2>

            {headerAction && (
              <div className="Modal__header__right">{headerAction}</div>
            )}
          </div>
        )}

        {afterHeader}

        <div className="Modal__body">{children}</div>

        {footer && <div className="Modal__footer">{footer}</div>}
      </WrapperEl>
    </div>,
    document.querySelector('#modals')
  )
}

export default Modal
